import { isInTwa } from '$func/environmentInfo'
import {
  setTwaHttpServerPort,
  setTwaWsServerUrl,
} from '$logic/twaCommunication'
import { SESSION_STORAGE_KEYS } from '$logic/client-device/types'
import { sessionStorageGetItem } from '$func/session-storage'

if (isInTwa) {
  const wsUrl = sessionStorageGetItem(SESSION_STORAGE_KEYS.TWA_WS_URL)
  if (wsUrl) setTwaWsServerUrl(wsUrl)
  else {
    const port = sessionStorageGetItem(SESSION_STORAGE_KEYS.TWA_PORT)
    if (port) setTwaHttpServerPort(port)
  }
}
